import { render, staticRenderFns } from "./myFaults.vue?vue&type=template&id=0b4529d1&scoped=true"
import script from "./myFaults.vue?vue&type=script&lang=js"
export * from "./myFaults.vue?vue&type=script&lang=js"
import style0 from "./myFaults.vue?vue&type=style&index=0&id=0b4529d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4529d1",
  null
  
)

export default component.exports